<script lang="ts">
	import { run } from "svelte/legacy"

	import { DataHandlerSnapshot } from "luxedo-data"
	import { InstructionSteps } from "misc-ui"

	interface Props {
		createOrSelect?: "Create your own" | "Working with a professional"
		stepIndex: any
		updateStepIndex: (stepIndex: number) => void
		selectedSnapshotId: number
	}

	let {
		createOrSelect = "Create your own",
		stepIndex,
		updateStepIndex,
		selectedSnapshotId,
	}: Props = $props()

	let resX: number
	let resY: number

	let steps = $state(
		createOrSelect === "Create your own"
			? {
					0: {
						title: "Download your snapshot",
						description: "This will serve as your template when creating your scene.",
					},
					1: {
						title: "Create and decorate your project",
						description: "Create a project with the snapshot resolution.",
					},
					2: {
						title: "Prepare for export",
						description: "Hide your snapshot and export your scene as an MP4.",
					},
					3: {
						title: "Upload your project",
						description: "Upload your masterpiece to begin playing on your Luxedo device!",
					},
				}
			: {
					0: {
						title: "Select your show",
						description: "Browse and select the show you want.",
					},
					1: {
						title: "Download your snapshot",
						description: "This will serve as your template when mapping scene.",
					},
					2: {
						title: "Upload your project",
						description: "Upload your selected show to begin playing on your Luxedo device!",
					},
				}
	)

	function updateResolution() {
		if (createOrSelect === "Working with a professional") return

		if (!selectedSnapshotId) {
			steps = {
				0: {
					title: "Download your snapshot",
					description: "This will serve as your template when creating your scene.",
				},
				1: {
					title: "Create and decorate your project",
					description: `Create a project with the snapshot resolution.`,
				},
				2: {
					title: "Prepare for export",
					description: "Hide your snapshot and export your scene as an MP4.",
				},
				3: {
					title: "Upload your project",
					description: "Upload your masterpiece to begin playing on your Luxedo device!",
				},
			}

			return
		}

		let snapshot = DataHandlerSnapshot.get(selectedSnapshotId)
		resX = snapshot.resolution.w
		resY = snapshot.resolution.h

		steps = {
			0: {
				title: "Download your snapshot",
				description: "This will serve as your template when creating your scene.",
			},
			1: {
				title: "Create your project",
				description: `Create a project with the snapshot resolution ${`(${resX}x${resY})`}.`,
			},
			2: {
				title: "Prepare for export",
				description: "Hide your snapshot and export your scene as an MP4.",
			},
			3: {
				title: "Upload your project",
				description: "Upload your masterpiece to begin playing on your Luxedo device!",
			},
		}
	}

	run(() => {
		;(selectedSnapshotId || !selectedSnapshotId) && updateResolution()
	})
</script>

<div class="flex-column">
	<h3>Creating your Scene</h3>

	<div id="direct-upload-instructions">
		<InstructionSteps onStepClick={updateStepIndex} {steps} index={stepIndex} />
	</div>
</div>

<style>
	.flex-column {
		flex-basis: 40%;
	}

	:global(.isMobile) .flex-column {
		flex-basis: unset;
	}

	:global(.isMobile) .flex-column h3 {
		display: none;
	}

	#direct-upload-instructions {
		margin-right: 1rem;
		margin-top: 1rem;
		padding-right: 1rem;
		border-right: 1px solid var(--color-border);
		margin-right: 1rem;
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		overflow-y: auto;
	}

	:global(.isMobile) #direct-upload-instructions {
		margin: 0;
		padding: 0;
		border: none;
	}

	:global(.isMobile) #direct-upload-instructions :global(.step-number) {
		display: none;
	}

	:global(.isMobile) #direct-upload-instructions :global(.step:not(.active)) {
		display: none;
	}

	:global(.isMobile) #direct-upload-instructions :global(.step-text svg) {
		display: none;
	}

	:global(.isMobile .direct-upload-container .upload-step) {
		display: none;
	}

	:global(.isMobile) #direct-upload-instructions :global(.step-text) {
		width: 100%;
		margin-right: 0;
		padding-right: 0;
		text-align: center;
	}

	:global(.isMobile) #direct-upload-instructions :global(.step-text) {
		font-size: var(--h2);
	}

	:global(.isMobile) #direct-upload-instructions :global(.step-text h3) {
		font-size: var(--h1);
	}
</style>
